import { createActionsHook, StoreActionApi } from 'react-sweet-state';

import {
  createGetAction,
  createGetOneHook,
  createLoadingHook,
  createRestActions,
  createRestStore,
  RestStoreState,
} from '@intelliarts/ia-react-template';

import { turnoverDashboardMapper } from '../turnoverMappers';
import type { TurnoverDashboardApiBody, TurnoverYearSnapshot } from '../turnoverTypes';

const actionConfig = {
  resourcePath: '/dashboards/turnover/snapshot',
};

type TurnoverSnapshotState = RestStoreState<TurnoverDashboardApiBody>;

const genericActions = createRestActions<TurnoverDashboardApiBody, TurnoverYearSnapshot>(
  actionConfig,
  turnoverDashboardMapper,
);

const turnoverSnapshotActions = {
  ...genericActions,
  loadForYear: (year: number) => async ({ dispatch, getState }: StoreActionApi<TurnoverSnapshotState>) => {
    const getAction = createGetAction<TurnoverDashboardApiBody>({
      resourcePath: actionConfig.resourcePath,
    });
    await dispatch(getAction({ params: { year } }));
    const { data: snapshotList } = getState();
    const first = snapshotList[0];
    return first ? turnoverDashboardMapper.toModel(first) : undefined;
  },
  clearTurnoverSnapshot: () => ({ setState }: StoreActionApi<TurnoverSnapshotState>) => {
    setState({ data: [], isLoading: false, changes: [] });
  },
};

export const TurnoverSnapshotStore = createRestStore<TurnoverYearSnapshot, TurnoverDashboardApiBody>({
  actions: turnoverSnapshotActions,
  actionConfig,
  containerDisplayName: 'turnover-snapshot-container',
  onInitAction: null,
  mapper: turnoverDashboardMapper,
});

export const useTurnoverSnapshotRecord = createGetOneHook(TurnoverSnapshotStore);
export const useTurnoverSnapshotIsLoading = createLoadingHook(TurnoverSnapshotStore);
export const useTurnoverSnapshotActions = createActionsHook(TurnoverSnapshotStore);
